import { type ElementBase } from './element-base';

export function getElement<T extends ElementBase>(
  key: string,
  elements: Map<string, ElementBase> | ElementBase[],
): T {
  if (Array.isArray(elements)) {
    return elements.find(e => e.key === key) as T;
  }

  return <T>elements.get(key);
}

export function getElementsByType<T extends ElementBase>(
  type: string,
  elements: ElementBase[] | Map<string, ElementBase>,
): T[] {
  if (!Array.isArray(elements)) {
    elements = Array.from(elements).map(([_, el]) => el);
  }

  return elements.filter(e => e.elementType === type) as T[];
}
